import { z } from 'zod/v4';

export const SystemDomainContract = z.object({
    id: z.number(),
    name: z.string(),
    status: z.number(),
});

// The system-domains endpoint returns the array unwrapped (no `{ data }` envelope).
export const SystemDomainCollectionResponseSchema = z.array(SystemDomainContract);

export type SystemDomain = z.infer<typeof SystemDomainContract>;
